import { CompletionRule } from 'app/library/course-offering/enums/completion-rule.enum';
import { Module } from './module.model';

export class CompletionRuleCommand {
    completion_rule: CompletionRule;
    required_sections_for_completion: number[];
    sections_completion_percentage: number | null;

    constructor(tempModule: Module, requiredSectionForCompletion?: string) {
        this.completion_rule = tempModule.completionRule;
        this.sections_completion_percentage =
            tempModule.completionRule === CompletionRule.AUTO_PERCENTAGE_OF_SECTIONS ? tempModule.sectionsCompletionPercentage ?? null : null;
        if (requiredSectionForCompletion) {
            this.required_sections_for_completion = [parseInt(requiredSectionForCompletion, 10)];
        }
    }
}
